import $ from 'jquery';
import { handleColorizeBw, handleAutocolor } from './index';

export default function initColorizeListeners() {
  $('body').on('click', '#editor-menu-image-colorizebw', handleColorizeBw);
  $('body').on('click', '#editor-menu-image-autocolor', handleAutocolor);
}
